var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    {
      staticClass: "remote-island-type",
      attrs: { label: _vm.label, prop: _vm.prop, rules: _vm.rules }
    },
    [
      _c(
        "el-select",
        {
          attrs: {
            placeholder: _vm.placeholder,
            disabled: _vm.disabled,
            autofocus: _vm.autofocus,
            clearable: false,
            filterable: false,
            "filter-method": _vm.filter
          },
          model: {
            value: _vm.remoteIslandType,
            callback: function($$v) {
              _vm.remoteIslandType = $$v
            },
            expression: "remoteIslandType"
          }
        },
        [
          _c("el-option", { attrs: { label: "", value: "" } }),
          _vm._l(_vm.options, function(item) {
            return _c(
              "el-option",
              {
                key: item.value,
                attrs: { label: item.label, value: item.value }
              },
              [
                _c(
                  "span",
                  { staticStyle: { float: "left", "margin-left": "10px" } },
                  [_vm._v(_vm._s(item.label))]
                )
              ]
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }